<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-kanban`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 11a2 2 0 012 2v28a2 2 0 01-2 2H4a2 2 0 01-2-2V13a2 2 0 012-2h40zm-2 4H6v24h36V15zM40 4v4H8V4h32z"/></svg>
</template>
<script>

export default {
  name: 'IconKanban',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
